import React from "react";
import { sortBy } from "lodash";

import CSSModules from "lib/utils/css-modules";
import {
  st,
  Form,
  FormMessage,
  FormControl,
  Button,
  AgentCooperationFullDecorator,
  Item,
  List,
  Image,
} from "lib/index";
import styles from "./EditAgentCooperationView.less";

const CompanyItem = ({ company }) => (
  <Item.Group>
    <Item>
      <Item.Image size="tiny" avatar src={st.getAttachmentImageUrl(company, "logo_image", "thumb")} />
      <Item.Content>
        <Item.Header>{company.name}</Item.Header>
        <Item.Meta>
          {company.contact_phone_number && (
            <span>
              <a className="with-icon" href={`tel:${company.contact_phone_number}`}>
                <i className="icon material-icons">phone</i>
                <span className="text">{company.contact_phone_number}</span>
              </a>
            </span>
          )}
          {company.contact_email && (
            <span>
              <a className="with-icon" href={`mailto:${company.contact_email}`}>
                <i className="icon material-icons">email</i>
                <span className="text">{company.contact_email}</span>
              </a>
            </span>
          )}
        </Item.Meta>
      </Item.Content>
    </Item>
  </Item.Group>
);

class AgentDealPricingFormSection extends React.PureComponent {
  handlePropChange(prop, value) {
    this.props.onChange({
      ...this.props.pricing,
      [prop]: value,
    });
  }

  render() {
    const { name, coop, pricing, onBlur, defaultCurrency, defaultPricing } = this.props;
    return (
      <FormControl.FormGroup label={name}>
        {coop.pricing_options.price_value_type === "relative" && st.authorize("read_price", coop) && (
          <FormControl.FormGroup inline>
            <span>{I18n.t("papp.agents.EditAgentCooperationView.price_change")}</span>
            <FormControl.Money
              value={pricing.price_relative_amount_or_percentage}
              placeholder={
                defaultPricing &&
                defaultPricing.price_relative_amount_or_percentage &&
                (defaultPricing.price_relative_amount_or_percentage.currency === "percentage"
                  ? defaultPricing.price_relative_amount_or_percentage
                  : { value: defaultPricing.price_relative_amount_or_percentage.value, currency: defaultCurrency })
              }
              onChange={this.handlePropChange.bind(this, "price_relative_amount_or_percentage")}
              currencies={[defaultCurrency]}
              withPercentageCurrency
              readOnly={!st.authorize("update_price", coop)}
            />
          </FormControl.FormGroup>
        )}
        {coop.pricing_options.price_value_type === "absolute" &&
          coop.pricing_options.price_includes_commision &&
          st.authorize("read_price", coop) &&
          pricing.product_pricelist_item && (
            <FormControl.FormGroup inline>
              <span>{I18n.t("papp.agents.EditAgentCooperationView.gross_price")}</span>
              <FormControl.Money
                value={pricing.price_absolute_amount}
                placeholder={pricing.product_pricelist_item.price}
                onChange={this.handlePropChange.bind(this, "price_absolute_amount")}
                readOnly={!st.authorize("update_price", coop)}
              />
            </FormControl.FormGroup>
          )}
        {coop.pricing_options.price_value_type === "absolute" &&
          !coop.pricing_options.price_includes_commision &&
          st.authorize("read_price", coop) &&
          pricing.product_pricelist_item && (
            <FormControl.FormGroup inline>
              <span>{I18n.t("papp.agents.EditAgentCooperationView.net_price")}</span>
              <FormControl.Money
                value={pricing.price_absolute_amount}
                placeholder={pricing.product_pricelist_item.price}
                onChange={this.handlePropChange.bind(this, "price_absolute_amount")}
                readOnly={!st.authorize("update_price", coop)}
              />
            </FormControl.FormGroup>
          )}
        {coop.pricing_options.commision_value_type === "absolute" && st.authorize("read_commision", coop) && (
          <FormControl.FormGroup inline>
            <span>{I18n.humanAttributeName("order", "agent_commision")}</span>
            <FormControl.Money
              value={pricing.commision_absolute_amount_or_percentage}
              placeholder={defaultPricing && defaultPricing.commision_absolute_amount_or_percentage}
              onChange={this.handlePropChange.bind(this, "commision_absolute_amount_or_percentage")}
              defaultCurrency={
                defaultPricing && defaultPricing.commision_absolute_amount_or_percentage ? undefined : "percentage"
              }
              withPercentageCurrency
              readOnly={!st.authorize("update_commision", coop)}
            />
            {coop.pricing_options.commision_includes_product_options_amount === null &&
              pricing.commision_absolute_amount_or_percentage &&
              pricing.commision_absolute_amount_or_percentage.currency === "percentage" && (
                <FormControl.Checkbox
                  label={I18n.t("papp.agents.EditAgentCooperationView.include_product_options_price")}
                  value={pricing.commision_includes_product_options_amount}
                  indeterminate={pricing.commision_includes_product_options_amount === null}
                  onChange={this.handlePropChange.bind(this, "commision_includes_product_options_amount")}
                  toggle
                  readOnly={!st.authorize("update_commision", coop)}
                  className="u-marginLeft"
                />
              )}
          </FormControl.FormGroup>
        )}
        {coop.pricing_options.service_fee_value_type === "absolute" && st.authorize("read_service_fee", coop) && (
          <FormControl.FormGroup inline>
            <span>{I18n.humanAttributeName("order", "agent_service_fee")}</span>
            <FormControl.Money
              value={pricing.service_fee_absolute_amount_or_percentage}
              placeholder={defaultPricing && defaultPricing.service_fee_absolute_amount_or_percentage}
              onChange={this.handlePropChange.bind(this, "service_fee_absolute_amount_or_percentage")}
              defaultCurrency={
                defaultPricing && defaultPricing.service_fee_absolute_amount_or_percentage ? undefined : "percentage"
              }
              withPercentageCurrency
              readOnly={!st.authorize("update_service_fee", coop)}
            />
            {coop.pricing_options.service_fee_includes_product_options_amount === null &&
              pricing.service_fee_absolute_amount_or_percentage &&
              pricing.service_fee_absolute_amount_or_percentage.currency === "percentage" && (
                <FormControl.Checkbox
                  label={I18n.t("papp.agents.EditAgentCooperationView.include_product_options_price")}
                  value={pricing.service_fee_includes_product_options_amount}
                  indeterminate={pricing.service_fee_includes_product_options_amount === null}
                  onChange={this.handlePropChange.bind(this, "service_fee_includes_product_options_amount")}
                  toggle
                  readOnly={!st.authorize("update_service_fee", coop)}
                  className="u-marginLeft"
                />
              )}
          </FormControl.FormGroup>
        )}
      </FormControl.FormGroup>
    );
  }
}

@CSSModules(styles)
export default class EditAgentCooperationForm extends React.PureComponent {
  handleSubmit(event) {
    event.preventDefault();
    this.props.onSubmit();
  }

  handlePropChange(prop, value) {
    const { coop, onChange } = this.props;
    const nextCoop = new AgentCooperationFullDecorator({
      ...coop,
      [prop]: value,
    });
    onChange(nextCoop);
  }

  handlePricingChange(nextAgentDealPricing) {
    const { coop, onChange } = this.props;
    const nextCoop = new AgentCooperationFullDecorator({
      ...coop,
      agent_deal_pricings: coop.agent_deal_pricings.map((adp) =>
        adp.id === nextAgentDealPricing.id ? nextAgentDealPricing : adp
      ),
    });
    onChange(nextCoop);
  }

  handleProductDealPropChange(agentProductDeal, prop, value) {
    const { coop, onChange } = this.props;
    const nextAgentProductDeal = { ...agentProductDeal, [prop]: value };
    const nextCoop = new AgentCooperationFullDecorator({
      ...coop,
      agent_product_deals: coop.agent_product_deals.map((apd) =>
        apd.id === nextAgentProductDeal.id ? nextAgentProductDeal : apd
      ),
    });
    onChange(nextCoop);
  }

  handleAllProductDealsPropChange(prop, value) {
    const { coop, onChange } = this.props;
    const nextCoop = new AgentCooperationFullDecorator({
      ...coop,
      agent_product_deals: coop.agent_product_deals.map((apd) => ({
        ...apd,
        [prop]: value,
      })),
    });
    onChange(nextCoop);
  }

  render() {
    const { coop, valid, errors, submitLoading, onBlur, currentCompanyId, currentCompany } = this.props;
    const coopCompanyType = currentCompanyId === coop.agent.id ? "supplier" : "agent";
    const coopCompany = coop[coopCompanyType];
    const pricingTypeOptions = coop.agent.is_st
      ? [
          ["st_realtime_pricing", I18n.humanAttributeName("agent_cooperation", "st_realtime_pricing")],
          ["st_fixed_net_pricing", I18n.humanAttributeName("agent_cooperation", "st_fixed_net_pricing")],
          ["st_fixed_gross_pricing", I18n.humanAttributeName("agent_cooperation", "st_fixed_gross_pricing")],
        ]
      : [
          ["realtime_pricing", I18n.humanAttributeName("agent_cooperation", "realtime_pricing")],
          ["fixed_net_pricing", I18n.humanAttributeName("agent_cooperation", "fixed_net_pricing")],
          ["fixed_gross_pricing", I18n.humanAttributeName("agent_cooperation", "fixed_gross_pricing")],
        ];
    const defaultPricing = coop.agent_deal_pricings.find((adp) => !adp.product && !adp.product_pricelist_item);
    const isCoopCompanySupplier = coopCompanyType === "supplier";

    return (
      <Form onSubmit={this.handleSubmit.bind(this)} error={!valid} loading={submitLoading}>
        <FormMessage error={errors.base} />

        <FormControl.FormGroup label={I18n.humanAttributeName("agent_cooperation", coopCompanyType)}>
          <CompanyItem company={coopCompany} />
        </FormControl.FormGroup>

        <FormControl.ButtonSwitchFormGroup
          label={I18n.humanAttributeName("agent_cooperation", "pricing_type")}
          value={coop.pricing_type}
          onChange={this.handlePropChange.bind(this, "pricing_type")}
          onBlur={onBlur}
          options={pricingTypeOptions}
          readOnly={!st.authorize("update_pricing_type", coop) || currentCompany.biz_type === "hotel"}
        />

        <AgentDealPricingFormSection
          name={I18n.t("papp.agents.EditAgentCooperationView.default_pricing")}
          coop={coop}
          pricing={defaultPricing}
          onChange={this.handlePricingChange.bind(this)}
          onBlur={onBlur}
          defaultCurrency={coop.supplier.default_product_price_currency}
        />

        <FormControl.FormGroup>
          <div styleName="products-header">
            <label>{I18n.t("papp.agents.EditAgentCooperationView.products")}</label>
            {coopCompanyType === "agent" && (
              <div styleName="products-all-checkbox">
                <FormControl.Checkbox
                  label={I18n.t("papp.agents.EditAgentCooperationView.activate_all")}
                  checked={coop.agent_product_deals.find((apd) => !apd.enabled_by_supplier) ? false : true}
                  onChange={(checked) => this.handleAllProductDealsPropChange("enabled_by_supplier", checked)}
                  onBlur={onBlur}
                  toggle
                />
              </div>
            )}
          </div>
          <div styleName="products">
            {sortBy(
              coop.agent_product_deals.filter((apd) => {
                if (!apd.product.active) {
                  return false;
                }
                return isCoopCompanySupplier ? apd.enabled_by_supplier : true;
              }),
              (apd) => apd.product.name.toLowerCase()
            ).map((apd) => (
              <div styleName="products-item" key={apd.id}>
                <div styleName="products-item-header">
                  <FormControl.Checkbox
                    checked={isCoopCompanySupplier ? apd.enabled_by_agent : apd.enabled_by_supplier}
                    onChange={this.handleProductDealPropChange.bind(
                      this,
                      apd,
                      isCoopCompanySupplier ? "enabled_by_agent" : "enabled_by_supplier"
                    )}
                    onBlur={onBlur}
                    toggle
                    className="u-marginRight"
                  />
                  <div styleName="products-item-header-name">{apd.product.name}</div>
                </div>
                {apd.enabled_by_supplier && (
                  <div styleName="products-item-content">
                    {sortBy(apd.product.product_variants, (pv) => pv.position).map((pv) => {
                      const pvPricings = sortBy(
                        coop.agent_deal_pricings.filter(
                          (adp) => adp.product_pricelist_item && adp.product_pricelist_item.product_variant_id === pv.id
                        ),
                        (adp) => adp.product_pricelist_item.position
                      );
                      return (
                        <div styleName="products-item-content-pv" key={pv.id}>
                          {pv.name && <div styleName="products-item-content-pv-name">{pv.name}</div>}
                          {pvPricings.map((adp) => (
                            <AgentDealPricingFormSection
                              key={adp.id}
                              name={
                                adp.product_pricelist_item.pricelist_type === "pricelist_by_order"
                                  ? null
                                  : adp.product_pricelist_item.display_name
                              }
                              coop={coop}
                              pricing={adp}
                              onChange={this.handlePricingChange.bind(this)}
                              onBlur={onBlur}
                              defaultCurrency={adp.product_pricelist_item.price.currency}
                              defaultPricing={defaultPricing}
                            />
                          ))}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            ))}
          </div>
        </FormControl.FormGroup>

        <button type="submit" disabled={submitLoading} hidden />
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/agents/EditAgentCooperationView/EditAgentCooperationForm.jsx